import React, { useContext } from "react"
import Icon from "@kit/design/icon"
import SocialIcon from "@kit/design/social-icon"

const createIcon = icon => props => <Icon name={icon} size="md" {...props} />
const createSocialIcon = icon => props => (
  <SocialIcon name={icon} size="md" {...props} />
)

const defaultIcons = {
  alignCenter: createIcon("center-align"),
  alignLeft: createIcon("left-align"),
  alignJustify: createIcon("paragraph-justified-align"),
  alignRight: createIcon("right-align"),
  bandsintown: createIcon("music-note"),
  blockquote: createIcon("quote"),
  bold: createIcon("text-bold"),
  button: createIcon("button"),
  color: createIcon("drop"),
  countdown: createIcon("stopwatch"),
  file: createIcon("upload-file"),
  fontSize: createIcon("text-size"),
  gallery: createIcon("image-gallery"),
  heading: createIcon("heading-1"),
  "heading-one": createIcon("heading-1"),
  "heading-two": createIcon("heading-2"),
  "heading-three": createIcon("heading-3"),
  "heading-four": createIcon("heading-4"),
  "heading-five": createIcon("heading-5"),
  "heading-six": createIcon("heading-6"),
  horizontalRule: createIcon("line"),
  html: createIcon("code"),
  image: createIcon("image"),
  images: createIcon("image-gallery"),
  instagram: createSocialIcon("instagram"),
  italic: createIcon("text-italic"),
  layout: createIcon("layout-masonry"),
  link: createIcon("link"),
  links: createIcon("link"),
  money: createIcon("money"),
  newsletter: createIcon("emails"),
  orderedList: createIcon("ordered-list"),
  paragraph: createIcon("paragraph"),
  personalization: createIcon("email-address"),
  plus: createIcon("plus"),
  product: createIcon("tag"),
  script: createIcon("code-file"),
  share: createIcon("share"),
  snippet: createIcon("cube"),
  socialIcons: createIcon("globe"),
  stopwatch: createIcon("stopwatch"),
  strikethrough: createIcon("text-strikethrough"),
  underline: createIcon("text-underline"),
  unorderedList: createIcon("unordered-list"),
  video: createIcon("video")
}

const IconContext = React.createContext(defaultIcons)

// Until we remove the old block toolbar we need
// to be able to delineate between which set of icons we should be using
export const useIcon = icon => {
  return useContext(IconContext)[icon]
}
